import { z } from "zod";

const envSchema = z.object({
  VITE_APP_NAME: z.string().default("StockSync"),
  VITE_APP_ENV: z.enum(["development", "staging", "production"]).default("development"),
  VITE_API_BASE_URL: z.string().default("/api/v1"),
  VITE_API_TIMEOUT: z.coerce.number().default(30000),
  VITE_DEMO_MODE: z
    .enum(["true", "false", ""])
    .default("true")
    .transform((v) => v !== "false"),
  VITE_DEFAULT_LOCALE: z.string().default("en"),
});

function validateEnv() {
  const result = envSchema.safeParse(import.meta.env);
  if (!result.success) {
    console.error("Invalid environment variables:", result.error.format());
    // Fall back to defaults rather than crashing the demo.
    return envSchema.parse({});
  }
  return result.data;
}

export const env = validateEnv();
